import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { ListItem } from '@sunwebgroup/uds-ui/list-item'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './QuestionRow.module.css'

export interface QuestionRowProps {
  label: string
  href: string
  icon: IconGlyph
}

export function QuestionRow({ label, href, icon }: QuestionRowProps) {
  return (
    <ListItem
      as="a"
      className={styles.row}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      variant="transparent"
    >
      <Typography variant="body-s-regular-tight">
        {label}
      </Typography>
      <Icon glyph={icon} size={16} className={styles.icon} />
    </ListItem>
  )
}
